import React, { useEffect, useRef } from "react"
import Image from "gatsby-image"
import "./slide.scss"
import { gsap } from "gsap"

const Slide = ({ project, index }) => {
    
  const { img, title, description } = project
  const slideRef = useRef(null)

  useEffect(() => {
    gsap.from(slideRef.current, {
      // duration: 2,
      x: index % 2 === 0 ? -300 : 300,
      opacity: 0,
      ease: "ease-in",
      scrollTrigger: {
        trigger: slideRef.current,
        start: "top bottom",
        end: "bottom 90%",
        scrub: true,
      },
    })
  }, [])

  return (
    <div ref={slideRef} className="project-slide">
      <div className="text-container">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
      <Image fluid={img.fluid} alt={title} />
    </div>
  )
}

export default Slide
